import { useSelector } from 'react-redux';
import { Col, Row } from 'antd';
import LandingPage from './LandingPage';
import React, { PropsWithChildren } from 'react';

interface LandingLayoutProps {
  showLanding?: boolean;
}
const LandingLayout: React.FC<PropsWithChildren<LandingLayoutProps>> = ({ children, showLanding }) => {
  // @ts-ignore
  const theme = useSelector((state) => state.theme.currentTheme);

  return (
    <div className={`${theme === 'light' ? 'bg-white' : ''}`}>
      <Row justify="center">
        <Col
          xs={20}
          sm={20}
          md={14}
          lg={12}
          xxl={14}
          className="d-flex flex-column flex-grow-1"
          style={{ minHeight: '100vh' }}
        >
          <div className="d-flex flex-column flex-grow-1 justify-content-center">
            <Row justify="center">
              <Col xs={24} sm={24} md={20} style={{ maxWidth: 500 }}>
                <a href="/">
                  <img style={{ width: '180px' }} className="my-7" src="/img/logo.png" alt="logo" />
                </a>
                {children}
                <div style={{ height: '6em' }} />
              </Col>
            </Row>
          </div>
        </Col>
        {showLanding && (
          <Col xs={24} sm={24} md={10} lg={12} xxl={10} className="d-flex flex-column">
            <LandingPage />
          </Col>
        )}
      </Row>
    </div>
  );
};

export default LandingLayout;
